import { render, staticRenderFns } from "./loginRegistration.vue?vue&type=template&id=3d00af68&scoped=true"
import script from "./loginRegistration.vue?vue&type=script&lang=js"
export * from "./loginRegistration.vue?vue&type=script&lang=js"
import style0 from "./loginRegistration.vue?vue&type=style&index=0&id=3d00af68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00af68",
  null
  
)

export default component.exports